/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Kageyo 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Busetsa": ["Busetsa", "Cyabuhimbiri", "Cyatoko", "Gitebwe", "Kaninga", "Kayenzi", "Kivugiza", "Nyarubuye", "Nyarusange", "Rugarama", "Rwikubo", "Tsima"],
  "Gituza": ["Bugarama", "Gisiza", "Kabacuzi", "Kigara", "Mpama", "Nyakabare", "Rwabihumbi"],
  "Kintu": ["Gakeri", "Jabiro", "Kigando", "Kirara", "Nyakabungo", "Rutoma", "Ryabushogoro"],
  "Nyagisozi": ["Agatare", "Kageyo", "Kashango", "Kinyana", "Nyabukobero", "Nyagisozi", "Rukira"]
};